import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../Redux";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../Components/Input";
import Select from "../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../Components/ErrorContainer";
import { getFormData } from "../../../helpers";

const Payees = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const payeeData = useSelector(
    (state) => state?.orderInvoicesReducer?.payeeList
  );

  console.log(payeeData, "payeeData");

  useEffect(() => {
    dispatch(actions?.getPayeeList());
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-1">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Payee List
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>

                      <div className="col-md-8 align-right details-button">
                        <div className="field text-right mt-3 mt-sm-0">
                          <div className="uploadBtn">
                            {" "}
                            <input
                              type="file"
                              onChange={(e) =>
                                dispatch(
                                  actions.postUploadPayeesList(
                                    getFormData({
                                      customer_file: e.target.files[0],
                                    })
                                  )
                                )
                              }
                              name="data[payee_file]"
                              id="payee_file"
                              class="inputfile inputfile-2"
                              data-multiple-caption="{count} files selected"
                            />
                            <label
                              class="btn green-btn-revert upload-icon"
                              for="payee_file"
                            >
                              {" "}
                              <span class="i-icon"> </span>{" "}
                              <span>Upload Payee</span>
                            </label>
                          </div>
                          <button
                            id="download"
                            class="btn green-btn-revert download-icon"
                            onClick={() => {
                              console.log("hikiiiii");
                              dispatch(actions?.getDownloadPayeesList());
                            }}
                          >
                            <i class="i-icon"> </i> Download
                          </button>
                          <button
                            onClick={() =>
                              history.push("/order/payees/new-payee", {
                                type: "add",
                              })
                            }
                            class="btn green-btn-revert add-plus addSp mx-0"
                            id="addCount"
                            type="button"
                          >
                            <i class="i-icon"> </i> Add Payee
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0 mt-3">
              <div className="container px-0">
                <div className="shadowclass mt-0">
                  <div className="table-responsive general-setting saved_order_ms">
                    <div className="orderList">
                      <div className="col d-flex align-items-center justify-content-between">
                        <h4 className="event-alert p-0 mb-0">Payees</h4>
                      </div>
                      <table className="checklist-table remove-space">
                        <thead>
                          <tr>
                            <th> Payee ID </th>
                            {payeeData?.parent_merchant_id > 0 && (
                              <th> Payee ID </th>
                            )}
                            {payeeData?.isShowLinkedData && (
                              <th> Account Name </th>
                            )}
                            <th> Status </th>
                            <th className="min-wd-150"> Category </th>
                            <th className="col-2"> Payee Name </th>
                            <th> Contact Name</th>
                            <th> Contact Phone Number </th>
                            <th className="min-wd-150"> Contact Email </th>
                            <th> Actions </th>
                          </tr>
                        </thead>
                        <tbody>
                          {payeeData?.payees?.map((el) => (
                            <tr>
                              <td>{el?.id}</td>
                              {payeeData?.parent_merchant_id > 0 && (
                                <td>{el?.parent_id ? el?.parent_id : "NA"}</td>
                              )}
                              {payeeData?.isShowLinkedData && (
                                <td>{el?.merchant?.account_name}</td>
                              )}
                              <td>
                                {el.status_id == 93 ? (
                                  <span class="green_tag"> Active </span>
                                ) : (
                                  <span class="bordered_tag"> Inactive </span>
                                )}
                              </td>
                              <td>{el?.payee_name}</td>
                              <td>{el?.finance_group?.name}</td>
                              <td>{el?.contact_name}</td>
                              <td>{el?.contact_number_1}</td>
                              <td>{el?.email}</td>
                              <td class="invent-first-col">
                                <div className="d-flex">
                                  <a
                                    onClick={() => {
                                      history.push("/order/payees/new-payee", {
                                        type: "edit",
                                        id: el.id,
                                      });
                                    }}
                                    class="circle_icon edit_tooltip"
                                  >
                                    <i class="iconSprites edit-icon"></i>
                                  </a>
                                  <a
                                    class={`circle_icon pwr_tooltip ${
                                      el?.status_id === 93 ? "on" : ""
                                    }`}
                                    onClick={() =>
                                      dispatch(
                                        actions?.postPayeeStatus({
                                          id: el?.id,
                                          status:
                                            el?.status_id === 93
                                              ? "inactive"
                                              : "active",
                                        })
                                      )
                                    }
                                  >
                                    <i class="iconSprites pwr-icon"></i>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Payees;
